.clearIcon {
  cursor: pointer;
}
.clearIcon:hover {
  color: red;
}
